export default __webpack_public_path__ + "5f3f4ef0e4c26786abcdb6b5e5804d8b.png";